import React from 'react';
import { Globe } from '@phosphor-icons/react';
import { useLanguage } from '../contexts/LanguageContext';

// (Msg 753) EN/ES pill toggle. Two variants: `pill` (desktop) and `icon`
// (mobile). Persists choice via LanguageContext → localStorage.
export const LanguageToggle = ({ variant = 'pill', className = '' }) => {
  const { lang, setLang, toggle } = useLanguage();

  if (variant === 'icon') {
    return (
      <button
        type="button"
        onClick={toggle}
        className={`inline-flex items-center gap-1 px-2 py-1 rounded-md border border-gray-300 text-gray-700 hover:border-[#FF6B35] hover:text-[#FF6B35] transition-colors ${className}`}
        aria-label={lang === 'en' ? 'Switch to Spanish' : 'Switch to English'}
        title={lang === 'en' ? 'Español' : 'English'}
        data-testid="lang-toggle-icon"
      >
        <Globe size={14} weight="bold" />
        <span className="text-[11px] font-black uppercase tracking-wider">{lang.toUpperCase()}</span>
      </button>
    );
  }
  return (
    <div
      role="group"
      aria-label="Language toggle"
      className={`inline-flex items-center bg-white border border-gray-300 rounded-full p-0.5 ${className}`}
      data-testid="lang-toggle-pill"
    >
      <button
        type="button"
        onClick={() => setLang('en')}
        className={`px-2.5 py-1 rounded-full text-[11px] font-black uppercase tracking-wider transition-colors ${lang === 'en' ? 'bg-[#FF6B35] text-white' : 'text-[#0B1220] hover:text-[#FF6B35]'}`}
        aria-pressed={lang === 'en'}
        data-testid="lang-en"
      >EN</button>
      <button
        type="button"
        onClick={() => setLang('es')}
        className={`px-2.5 py-1 rounded-full text-[11px] font-black uppercase tracking-wider transition-colors ${lang === 'es' ? 'bg-[#FF6B35] text-white' : 'text-[#0B1220] hover:text-[#FF6B35]'}`}
        aria-pressed={lang === 'es'}
        data-testid="lang-es"
      >ES</button>
    </div>
  );
};

export default LanguageToggle;
